export default __webpack_public_path__ + "static/media/company-news.78c15444.svg";